import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { FaPlay } from '@react-icons/all-files/fa/FaPlay'
import { FaPause } from '@react-icons/all-files/fa/FaPause'
import { FaStop } from '@react-icons/all-files/fa/FaStop'

const SpeakerControls = styled.div`
  button {
    margin: 5px;
  }
`
const TextSpeech = ({ text }) => {
  const [volume, setVolume] = useState(1)
  const [rate, setRate] = useState(0.8)
  const [pitch, setPitch] = useState(1)

  function speak() {
    if ('speechSynthesis' in window) {
      var msg = new SpeechSynthesisUtterance()
      msg.text = text
      // Set the attributes.
      msg.volume = parseFloat(volume)
      msg.rate = parseFloat(rate)
      msg.pitch = parseFloat(pitch)
      msg.lang = 'zh-CN'
      msg.voice = speechSynthesis.getVoices().filter(function (voice) {
        return voice.name == 'Google 普通话（中国大陆）'
      })[0]
      window.speechSynthesis.resume()
      window.speechSynthesis.speak(msg)
    }
  }

  function pause() {
    if (speechSynthesis.speaking) {
      window.speechSynthesis.pause()
    }
  }

  function cancel() {
    window.speechSynthesis.cancel()
  }
  function handleVolumeChange(e) {
    setVolume(e.target.value)
  }
  function handleRateChange(e) {
    setRate(e.target.value)
  }
  function handlePitchChange(e) {
    setPitch(e.target.value)
  }

  return (
    <div id="page-wrapper">
      <div className="option">
        <label htmlFor="volume">音量</label>
        <input
          type="range"
          min={0}
          max={1}
          step="0.1"
          name="volume"
          id="volume"
          defaultValue={volume}
          onChange={handleVolumeChange}
        />
      </div>
      <div className="option">
        <label htmlFor="rate">语速</label>
        <input
          type="range"
          min="0.1"
          max={10}
          step="0.1"
          name="rate"
          id="rate"
          defaultValue={rate}
          onChange={handleRateChange}
        />
      </div>
      <div className="option">
        <label htmlFor="pitch">音调</label>
        <input
          type="range"
          min={0}
          max={2}
          step="0.1"
          name="pitch"
          id="pitch"
          defaultValue={pitch}
          onChange={handlePitchChange}
        />
      </div>
      <SpeakerControls className="option speaker-controls">
        <button id="speak" onClick={speak}>
          朗读 <FaPlay />
        </button>
        <button id="pause" onClick={pause}>
          暂停 <FaPause />
        </button>
        <button id="resume" onClick={cancel}>
          取消 <FaStop />
        </button>
      </SpeakerControls>
    </div>
  )
}

export default TextSpeech
